import Vue from 'vue'
import Vuex from 'vuex'
import {Toast} from "vant";
import Cookies from 'js-cookie'
import i18n, { getLanguage } from '@/lang'


/*const bus = new Vue()*/

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: getLanguage(),
    taskId: '',
    componentsList: [],
    controlIndex: 0,
    backUrl: '',
    sceneList: {},
    progranList: {},
    topTitle: i18n.t('append_field.home'),
    topBackIconShow: false,
    parentPage: '',
    dels: [],
    width: 1920,
    height: 1080,
    scId: "",
    previewPages: {
      setting: {
        bjSwitch: true,  // 是否开启背景音乐
        loopPlay: true,  // 背景音乐是否循环播放
        autoPlay: true,  // 背景音乐是否自动播放
        musicName: "", // 背景音乐名称
        musicUrl: "", // 背景音乐名称
        PlaySpeed: 3000,  // 页面停留时间
        speed: 3000,  // 页面动画时间
        pageAnimation: "slide", // 页面动画
        autoPage: true, // 自动翻页
        direction: 'vertical', // 切换方向
      },
      pageList: [{
        pageBg: "",
        node: []
      }]
    }, //预览的
    pageIndex: 0,
    selectedComponent:null,
    form: {
      name: '',
      mainResolution: '1',
      classify: '1',
      taskType: '1',
    },
    scanResult: null
  },
  getters: {
    language: state => state.language,
    scanResult: state => state.scanResult
  },
  mutations: {
    setSelectedComponent(state, index) {
      state.selectedComponent = index;
    },
    reSetTaskId(state, n) {
      state.taskId = n
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    setScanResult(state, scanResult) {
      state.scanResult = scanResult;
    },

  },
  actions: {
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    addControl({state}, data) {

      for (let i = 0; i < state.componentsList.length; i++) {
        if (data === 'hdmin' && state.componentsList[i].coType === 'hdmin' && !(state.dels.includes(state.componentsList[i].id))) {
          Toast('HDMI'+i18n.t('append_field.onlyOne'))
          return
        }

      }
      let taContent=''
      switch (data) {
        case 'date':
          taContent = function f() {
            const date = new Date()
            const y = date.getFullYear()
            const m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
            const d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            return [y, m, d].join('-')
          }()
          break
        case 'weeks':
          taContent = function f() {
            const date = new Date()
            const weeks = [i18n.t('append_field.Sunday'), i18n.t('append_field.Monday'), i18n.t('append_field.Tuesday'), i18n.t('append_field.Wednesday'),
              i18n.t('append_field.Thursday'), i18n.t('append_field.Friday'), i18n.t('append_field.Saturday')]
            const m = date.getDay()
            return weeks[m]
          }()
          break
        case 'time':
          taContent = function f() {
            const date = new Date()
            const h = date.getHours()
            const m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
            const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            return [h, m, s].join(':')
          }()
          break
        default:
          taContent =''
          break
      }
      state.componentsList.push({
          infoX: '0',
          infoY: '0',
          infoWidth: '600',
          infoHeight: '600',
          coActionType: '',
          coHeight: '600',
          coLeftPosition: '0',
          coLinkAction: '',
          coPsId: '1',
          coRightPosition: '0',
          coScId: '',
          coScreenProtectTime: '10',
          coState: '1',
          coType: data,
          coWidth: '600',
          id: function f() {
            const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't']
            let str = ''
            for (let i = 0; i < 12; i++) {
              str += arr[Math.floor(Math.random() * arr.length)]
            }
            return str
          }(),
          txList: [{
            id: '',
            taBgColor: '#00000000',
            taColor: '#000000',
            taContent: taContent,
            taAlignment: '5',
            taFontSize: '70',
            taMove: '1',
            taMoveSpeed: '1',
          }],
          mpList: [],
        })
    },
    addImages({state}, data) {
      data.map(res => {
        state.componentsList[state.controlIndex].mpList.push({
          cartoon: '1',
          cmId: '',
          mid: res.mtId,
          playParam: '10',
          size: res.mtSize,
          sort: 0,
          type: 'img',
          screenShotUrl:res.screenshotUrl?res.screenshotUrl:res.url,
          url: res.url,
          volume: '70',
        })
      })
    },
    addVideos({state}, data) {

      data.map(res => {
        state.componentsList[state.controlIndex].mpList.push({
          cartoon: '1',
          cmId: '',
          mid: res.mtId,
          playParam: '10',
          size: res.mtSize,
          sort: 0,
          type: 'video',
          viewUrl: res.videoViewUrl,
          volume: '70',
        })
      })
    },
    addMixture({state},data){

      data.map(res => {
        if (res.type === 'img') {
          state.componentsList[state.controlIndex].mpList.push({
            cartoon: '1',
            cmId: '',
            mid: res.mtId,
            playParam: '10',
            size: res.mtSize,
            sort: 0,
            type: 'img',
            url: res.screenshotUrl,
            volume: '70',
          })
        } else if (res.type === 'video') {

          state.componentsList[state.controlIndex].mpList.push({
            cartoon: '1',
            cmId: '',
            mid: res.mtId,
            playParam: '10',
            size: res.mtSize,
            sort: 0,
            type: 'video',
            viewUrl: res.videoViewUrl,
            volume: '70',
          })
        }


      })

    },
    addSubtitle({state}, data) {
      state.componentsList[state.controlIndex].txList[0].taContent = data.data
    },
    addDoc({state}, data){
      data.map(res => {
        state.componentsList[state.controlIndex].mpList.push({
          cartoon: '1',
          cmId: '',
          mid: res.mtId,
          playParam: '10',
          size: res.mtSize,
          sort: 0,
          type: 'doc',
          url: res.url,
          volume: '70',
          suffix:res.suffix,
          name:res.name
        })
      })
    },
    addAudios({state}, data) {

      data.map(res => {
        state.componentsList[state.controlIndex].mpList.push({
          cartoon: '1',
          cmId: '',
          mid: res.mtId,
          playParam: '10',
          size: res.mtSize,
          sort: 0,
          type: 'audio',
          url: res.url,
          volume: '70',
          name:res.name
        })
      })
    },
    emptyCanvns({state}) {
      state.backUrl = ''
      state.componentsList = []

    },
    addBackground({state}, data) {
      state.backUrl = data.url
      state.sceneList.scBackImg = data.url
      state.sceneList.scBackimgSize = data.mtSize
      state.sceneList.scBackImgId = data.mtId
    },
    //修改头部标题
    changeTopTitle({state}, data) {
      state.topTitle = data
    },
    //设置父级页面，用于返回操作
    setParentPage({state}, data) {
      state.parentPage = data
    },
    //设置头部返回icon显示
    changeTopIconStatus({state}, data) {
      state.topBackIconShow = data
    },
    //主屏分辨率
    mainGambian({state}, W) {
      for (let i = 0; i < W[0].length; i++) {
        if (W[0][i].id === W[1]) {
          state.mainResolutionW = parseInt(W[0][i].ruLPixel)
          state.mainResolutionH = parseInt(W[0][i].ruWPixel)
        }
      }
    },
  },
  modules: {},
})
